import {useAppSelector} from "../../store/hooks";

export const useGetPriceAlertInfo = (propertyId: number) => {
    const favourites = useAppSelector((state) => state.favourite.favourites);
    // Get the newest favourite for the property (in case there are multiple due to re-adding after removal)
    const newestFavouriteForProperty = favourites.list
        .filter((fav) => fav.property?.rp_id === propertyId && !fav.is_deleted)
        .sort((a, b) => new Date(b.update_date || 0).getTime() - new Date(a.update_date || 0).getTime())[0];

    return {hasAlertOn: newestFavouriteForProperty?.price_alerts ?? false};
};
import {useAppSelector} from "../../store/hooks";

export const useGetPriceAlertInfo = (propertyId: number) => {
    const favourites = useAppSelector((state) => state.favourite.favourites);
    // Get the newest favourite for the property (in case there are multiple due to re-adding after removal)
    const newestFavouriteForProperty = favourites.list
        .filter((fav) => fav.property?.rp_id === propertyId && !fav.is_deleted)
        .sort((a, b) => new Date(b.update_date || 0).getTime() - new Date(a.update_date || 0).getTime())[0];

    return {hasAlertOn: newestFavouriteForProperty?.price_alerts ?? false};
};
